import Typography from '@mui/material/Typography';
import CallerID from './CallerID';
import { formatPhoneNumber } from 'utils';
import Box from '@mui/material/Box';
import Button from 'components/Button';
import CallEndIcon from '@mui/icons-material/CallEnd';
import React from 'react';

const Calling = ({ to, onHangUp }) => {
  return (
    <Box textAlign="center" p={3}>
      <Typography fontWeight={500} variant="subtitle1">
        Calling...
      </Typography>
      <CallerID from={formatPhoneNumber(to)} />
      <Box my={3}>
        <Button
          rounded
          fullWidth
          sx={{
            borderRadius: 30,
          }}
          onClick={onHangUp}
          color="error"
          startIcon={<CallEndIcon />}
        >
          Hang up
        </Button>
      </Box>
    </Box>
  );
};

export default Calling;
